/* global axios */
import ApiClient from './ApiClient';

// VibeVox «Перехват ИИ»: вкл/выкл авто-ответа ИИ для текущего диалога.
// account_id берётся автоматически из URL (accountScoped); conversation_id — числовой id диалога.
// Бьёт в наш Rails-прокси (controllers/api/v1/accounts/vibevox_ai_controller.rb),
// который уже server-side ходит в VibeVox с секретом — секрет в браузер не попадает.
class VibevoxAi extends ApiClient {
  constructor() {
    super('vibevox_ai', { accountScoped: true });
  }

  getState(conversationId) {
    return axios.get(this.url, { params: { conversation_id: conversationId } });
  }

  setState(conversationId, enabled) {
    return axios.patch(this.url, { conversation_id: conversationId, enabled });
  }
}

export default new VibevoxAi();
